import React, { useState, useEffect, useRef } from "react";
import { Carousel, Card, Form, Button, Col } from "react-bootstrap";
import { useAuth } from "../Context/AuthContext";
import { useHttpClient } from "../hooks/http-hook";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next"; // Importer useTranslation

function AddProgram() {
  const navigate = useNavigate();
  const { sendRequest } = useHttpClient();
  const { authData } = useAuth();
  const { t } = useTranslation(); // Assigner useTranslation à {t}
  const [index, setIndex] = useState(0);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    categorie: "",
    level: "",
    language: "",
    duration: "",
    created_by: authData.userId,
    is_public: false,
  });
  const [imageFile, setImageFile] = useState(null);

  // Auto-resize textarea
  const textareaRef = useRef(null);
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height =
        textareaRef.current.scrollHeight + "px";
    }
  }, [formData.description]);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleFileChange = (e) => {
    setImageFile(e.target.files[0]);
  };

  const addProgram = async () => {
    const formDataToSend = new FormData();
    for (const key in formData) {
      formDataToSend.append(key, formData[key]);
    }
    if (imageFile) {
      formDataToSend.append("image", imageFile);
    }

    try {
      const response = await sendRequest(
        process.env.REACT_APP_BACKEND_URL + "/programs",
        "POST",
        formDataToSend
      );

      if (!response.program) {
        console.log(response.message);
        return;
      }

      navigate("/myprograms");
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="d-flex justify-content mt-4">
      <Card
        style={{
          maxWidth: "800px",
          width: "100%",
          padding: "20px",
          margin: "auto",
          borderRadius: "10px",
          boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
        }}
      >
        <Card.Body>
          <h3 className="mb-3 text-center">{t("create_new_program")}</h3>

          <Carousel
            activeIndex={index}
            onSelect={handleSelect}
            indicators={false}
            controls={false}
            intervall={null}
          >
            {/* Titre et description */}
            <Carousel.Item>
              <Form.Group className="mb-3">
                <Form.Label>{t("program_title")}</Form.Label>
                <Form.Control
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  placeholder={t("enter_program_title")}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>{t("program_description")}</Form.Label>
                <Form.Control
                  ref={textareaRef}
                  as="textarea"
                  rows={10}
                  placeholder={t("enter_program_description")}
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  maxLength={500}
                  style={{ overflow: "hidden", resize: "none" }}
                />
              </Form.Group>
              <Button
                disabled={
                  !formData.title.trim() || !formData.description.trim()
                }
                onClick={() => setIndex(1)}
                className="w-100"
              >
                {t("next")}
              </Button>
            </Carousel.Item>

            {/* Catégorie, niveau, langue et durée */}
            <Carousel.Item>
              <Form.Group className="mb-3">
                <Form.Label>{t("category")}</Form.Label>
                <Col>
                  <Form.Select
                    name="categorie"
                    aria-label="categorie"
                    onChange={handleChange}
                    value={formData.categorie}
                    required
                  >
                    <option value="" disabled>
                      {t("choose_category")}
                    </option>
                    <option value="Web Development">
                      {t("web_development")}
                    </option>
                    <option value="Mobile Development">
                      {t("mobile_development")}
                    </option>
                    <option value="Data Science">{t("data_science")}</option>
                  </Form.Select>
                </Col>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>{t("level")}</Form.Label>
                <Col>
                  <Form.Select
                    name="level"
                    aria-label="Level"
                    value={formData.level}
                    onChange={handleChange}
                    required
                  >
                    <option value="" disabled>
                      {t("choose_level")}
                    </option>
                    <option value="Beginner">{t("beginner")}</option>
                    <option value="Intermediate">{t("intermediate")}</option>
                    <option value="Advanced">{t("advanced")}</option>
                  </Form.Select>
                </Col>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>{t("language")}</Form.Label>
                <Col>
                  <Form.Select
                    name="language"
                    aria-label="Language"
                    onChange={handleChange}
                    value={formData.language}
                    required
                  >
                    <option value="" disabled>
                      {t("choose_language")}
                    </option>
                    <option value="French">{t("french")}</option>
                    <option value="English">{t("english")}</option>
                    <option value="Spanish">{t("spanish")}</option>
                  </Form.Select>
                </Col>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>{t("duration")}</Form.Label>
                <Form.Control
                  type="number"
                  name="duration"
                  value={formData.duration}
                  onChange={handleChange}
                  placeholder={t("enter_duration")}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>{t("image")}</Form.Label>
                <Form.Control
                  type="file"
                  name="image"
                  onChange={handleFileChange}
                  placeholder={t("upload_image")}
                />
              </Form.Group>
              <Button onClick={() => setIndex(0)} className="w-100">
                {t("previous")}
              </Button>
              <Button
                disabled={
                  !formData.categorie.trim() ||
                  !formData.level.trim() ||
                  !formData.duration.trim() ||
                  !formData.level.trim()
                }
                onClick={() => setIndex(2)}
                className="w-100 mt-3"
              >
                {t("next")}
              </Button>
            </Carousel.Item>

            {/* Résumé */}
            <Carousel.Item>
              <h4>{t("summary")}</h4>
              <p>
                <strong>{t("title")}:</strong> {formData.title}
              </p>
              <p>
                <strong>{t("description")}:</strong> {formData.description}
              </p>
              <p>
                <strong>{t("category")}:</strong> {formData.categorie}
              </p>
              <p>
                <strong>{t("level")}:</strong> {formData.level}
              </p>
              <p>
                <strong>{t("language")}:</strong> {formData.language}
              </p>
              <p>
                <strong>{t("duration")}:</strong> {formData.duration}{" "}
                {t("hours")}
              </p>
              <Button onClick={() => setIndex(1)} className="w-100">
                {t("previous")}
              </Button>
              <Button onClick={() => addProgram()} className="w-100 mt-3">
                {t("create_program")}
              </Button>
            </Carousel.Item>
          </Carousel>
        </Card.Body>
      </Card>
    </div>
  );
}

export default AddProgram;
